import { NotificationService } from '../../services/notification.service';
import { Component, Input, OnInit } from '@angular/core';
import { OverlayService } from '../../services/overlay.service';
import { Store } from '../../store';
import { AlertService } from '../../services/alert.service';
import { AlertConfirmData, defaultAlertConfirmData } from 'src/app/data-types/alert-data';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent implements OnInit
{
    @Input() showRead = true;
    @Input() aside = true;

    notifications$ = this.store.select<any[]>('notifications');
    displayButton: boolean;
    private routeMap;

    constructor(
        private overlayService: OverlayService,
        private store: Store,
        public notificationsService: NotificationService,
        private alertService: AlertService,
        private _router: Router
    )
    {
    }


    ngOnInit(): void
    {
        const notifications = this.store.selectForLocal('notifications');
        // notifications.unread = 0;
        this.displayButton = notifications.data.length > 1 ? true : false;
        this.routeMap = notifications.routeMap?.admin;
        this.store.set('notifications', notifications);

    }

    delete(notification)
    {
        const notifications = this.store.selectForLocal('notifications');
        notifications.data.forEach((n, idx) =>
        {
            if (n.id === notification.id) {
                notifications.data.splice(idx, 1);
                if (!notification.isRead) {
                    notifications.unread--;
                }
            }
        });
        this.store.set('notifications', notifications);

        this.notificationsService.delete(notification.id).subscribe();

    }

    markAsRead(notification, $event)
    {
        $event.preventDefault();
        $event.stopPropagation();

        notification.isRead = true;
        const notifications = this.store.selectForLocal('notifications');
        notifications.unread--;
        this.store.set('notifications', notifications);
        this.notificationsService.markAsRead(notification.id).subscribe();
    }

    checkForClosing()
    {
        const notifications = this.store.selectForLocal('notifications');

        // let deleteCount = 0;
        let readCount = 0;
        notifications.data.forEach(n =>
        {
            if (!n.isRead) {
                readCount++;
            }
        });
        if (!readCount) {
            this.close();
        }
    }

    close()
    {
        this.overlayService.closeAll();
    }

    deleteAll()
    {
        this.alertService
            .confirm({
                    ...defaultAlertConfirmData,
                    title: 'Are you Sure',
                    confirmText: "Yes",
                    confirmCb: this.clearNotifications.bind(this)
                } as AlertConfirmData
            );
    }

    clearNotifications()
    {
        const LoggedInUserData = localStorage.getItem('yssAdminUser');
        if (LoggedInUserData) {

            const userData = JSON.parse(LoggedInUserData);
            this.notificationsService.deleteAll(userData.user.id).subscribe((res) =>
            {
                if (res.data) {
                    this.store.set('notifications', { unread: 0, data: [] });
                    this.close();
                    this.displayButton = false;
                }
            });
        }
    }

    public navigateToNotificationList()
    {
        this._router.navigateByUrl('notifications');
        this.close();
    }

    getNotificationRoute(notification): string | null
    {
        return this.routeMap[notification.type];
    }

    public navigateByNotificationType(notification): void
    {
        const routeString = this.getNotificationRoute(notification);
        if (routeString) {
            const commands = routeString.split('/').map(item => {
                if (item[0] === '$') {
                    return notification[item.slice(1)];
                }
                return item;
            });
            if (commands) {
                this.store.set("activeNotification", notification);
                this._router.navigate(commands);
                this.close();
            }
        }
    }
}
